import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MyTasks from "@/pages/MyTasks";
import TeamTasks from "@/pages/TeamTasks";
import ApprovalInbox from "@/pages/ApprovalInbox";
import OrgStructure from "@/pages/OrgStructure";
import AuditLog from "@/pages/AuditLog";
import SettingsPage from "@/pages/Settings";
import Missions from "@/pages/Missions";
import Proposals from "@/pages/Proposals";
import Targets from "@/pages/Targets";
import Routines from "@/pages/Routines";
import Meetings from "@/pages/Meetings";
import Monthly from "@/pages/Monthly";
import Initiatives from "@/pages/Initiatives";
import Reviews from "@/pages/Reviews";
import UsersPage from "@/pages/Users";
import Forms from "@/pages/Forms";
import FormBuilder from "@/pages/FormBuilder";
import FormFill from "@/pages/FormFill";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="flex h-screen items-center justify-center text-slate-400">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Gated({ feature, children }) {
  const { user } = useAuth();
  const feats = user?.features;
  if (Array.isArray(feats) && feature && !feats.includes(feature)) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return <div className="flex h-screen items-center justify-center text-slate-400">Memuat...</div>;
  if (user) {
    const next = new URLSearchParams(loc.search).get("next");
    return <Navigate to={next && next.startsWith("/f/") ? next : "/"} replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/f/:id" element={<FormFill />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/tugas-saya" element={<Gated feature="tugas-saya"><MyTasks /></Gated>} />
            <Route path="/tugas-tim" element={<Gated feature="tugas-tim"><TeamTasks /></Gated>} />
            <Route path="/persetujuan" element={<Gated feature="persetujuan"><ApprovalInbox /></Gated>} />
            <Route path="/misi" element={<Gated feature="misi"><Missions /></Gated>} />
            <Route path="/pengajuan" element={<Gated feature="pengajuan"><Proposals /></Gated>} />
            <Route path="/target" element={<Gated feature="target"><Targets /></Gated>} />
            <Route path="/rutin" element={<Gated feature="rutin"><Routines /></Gated>} />
            <Route path="/rapat" element={<Gated feature="rapat"><Meetings /></Gated>} />
            <Route path="/bulanan" element={<Gated feature="bulanan"><Monthly /></Gated>} />
            <Route path="/inisiatif" element={<Gated feature="inisiatif"><Initiatives /></Gated>} />
            <Route path="/evaluasi" element={<Gated feature="evaluasi"><Reviews /></Gated>} />
            <Route path="/form" element={<Gated feature="form"><Forms /></Gated>} />
            <Route path="/form/:id" element={<Gated feature="form"><FormBuilder /></Gated>} />
            <Route path="/struktur" element={<Gated feature="struktur"><OrgStructure /></Gated>} />
            <Route path="/audit" element={<Gated feature="audit"><AuditLog /></Gated>} />
            <Route path="/pengguna" element={<Gated feature="pengguna"><UsersPage /></Gated>} />
            <Route path="/pengaturan" element={<Gated feature="pengaturan"><SettingsPage /></Gated>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </BrandingProvider>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
